"use strict";var Type=require("./Type"),$floor=Math.floor;module.exports=function(x){return"BigInt"===Type(x)?x:$floor(x)};